window.addEventListener('load', function () {
  fetch(window.location.pathname + '?sections=' + mmGetSectionCartId());
});

// Splide init
function mmInitSplide() {
  const id = '.splide-mm-cart';
  const splideElems = document.querySelectorAll(id);

  if (splideElems) {
    splideElems.forEach(function (splideElem) {
      new Splide(splideElem, {
        type: 'splide',
        arrows: true,
        pagination: false,
        autoplay: false,
        interval: 4000,
        rewind: true,
        gap: 20,
        fixedHeight: '220px',
        direction: 'ttb',
        height: '100%',
        breakpoints: {
          10000: {
            direction: 'ttr',
            perPage: 1,
            fixedHeight: 'auto',
            padding: {
              right: '10%',
              left: '10%',
            },
          },
        },
      }).mount();
    })
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    mmInitSplide();
    // mmGetFreeProductsVariantId();
  },
  { once: true }
);

function debounce(func, duration) {
  let timeout;
  return function (...args) {
    const effect = () => {
      timeout = null;
      return func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(effect, duration);
  };
}

function mmGetSectionCartId() {
  return document.getElementById('shopify-section-mm-cart').closest('.shopify-section').id.replace('shopify-section-', '');
}

function mmCartSectionElement() {
  return document.getElementById('shopify-section-mm-cart').closest('.shopify-section');
}

function mmCartProductsContainerElement() {
  return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

function mmCartItem(productVariantId) {
  return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartProduct(productId) {
  return mmCartProductsContainerElement().querySelector(`[data-cart-product-id="${productId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
  const itemEl = mmCartItem(productVariantId);

  return itemEl.querySelector('[data-item-quantity]');
}

function mmGetCartItemQuantity(productVariantId) {
  const quantityEl = mmCartItemQuantityEl(productVariantId);
  return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
  if (newQuantity >= 0) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    quantityEl.dataset.itemQuantity = newQuantity;
    quantityEl.innerText = newQuantity;
  }
}

function mmCartHTMLFromData(data) {
  const el = document.createElement('DIV');
  el.innerHTML = data.sections[mmGetSectionCartId()]
    .replaceAll('<cart-discount', '<b-cart-discount')
    .replaceAll('</cart-discount', '</b-cart-discount')
    .replaceAll('<discount-popup', '<b-discount-popup')
    .replaceAll('</discount-popup', '</b-discount-popup');

  return el;
}

function extractItemsFromCartHTML(data) {
  const el = mmCartHTMLFromData(data);
  return el.querySelector('.mm-dc-products-container');
}

function insertCartProductsFromResponse(data) {
  const itemsContainer = extractItemsFromCartHTML(data);
  mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

  const newCartEl = document.createElement('DIV');
  newCartEl.innerHTML = data.sections[mmGetSectionCartId()]
    .replaceAll('<cart-discount', '<b-cart-discount')
    .replaceAll('</cart-discount', '</b-cart-discount')
    .replaceAll('<discount-popup', '<b-discount-popup')
    .replaceAll('</discount-popup', '</b-discount-popup');
  document.querySelector('cart-discount').outerHTML = newCartEl
    .querySelector('b-cart-discount')
    .outerHTML.replaceAll('<b-cart-discount', '<cart-discount')
    .replaceAll('</b-cart-discount', '</cart-discount')
    .replaceAll('<b-discount-popup', '<discount-popup')
    .replaceAll('</b-discount-popup', '</discount-popup');

  return data;
}

function extractTotalPriceFromCartHTML(data) {
  const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
  return cartEl.querySelector('[data-cart-total-price]');
}

function extractOriginalPriceFromCartHTML(data) {
  const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
  return cartEl.querySelector('[data-cart-original-price]');
}

function extractTotalProductsFromCartHTML(data) {
  const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
  return cartEl.querySelector('[data-cart-total-price]');
}

function extractFooterFromCartHTML(data) {
  const cartEl = mmCartHTMLFromData(data);
  return cartEl.querySelector('.mm-dc-bottom');
}

function insertInsertTotalPriceFromResponse(data) {
  const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
  const newOriginalPriceEl = extractOriginalPriceFromCartHTML(data);
  const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
  const currentOriginalPriceEl = mmCartSectionElement().querySelector('[data-cart-original-price]');

  currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
  if (parseFloat(newOriginalPriceEl.innerHTML) != parseFloat(newTotalPriceEl.innerHTML)) {
    currentOriginalPriceEl.innerHTML = newOriginalPriceEl.innerHTML.replace('€', ' €');
    currentOriginalPriceEl.classList.remove('hidden');
  } else {
    currentOriginalPriceEl.classList.add('hidden');
  }
  return data;
}

async function mmAPIRequest(method, path, body) {
  document.querySelector('.mm-dc-products').classList.add('mm-inactive');
  return await fetch(window.Shopify.routes.root + path, {
    method: method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      document.querySelector('.mm-dc-products').classList.remove('mm-inactive');
      //document.querySelector('.cart-count-bubble > span').innerText = data.item_count;

      if (mmCartSectionElement().querySelector('.mm-dc-free-item-progress--inner')) {
        const freeItemsProgress = mmCartSectionElement().querySelector('.mm-dc-free-item-progress--inner');
        const newWidth = (data.total_price / document.getElementById('mmCartProgressBarValue').value) * 100;
        freeItemsProgress.style.width = `${newWidth}%`;

        if (data.total_price >= document.getElementById('mmCartProgressBarValue').value) {
          document.querySelector('.mm-dc-free-item-progress-text_succes').style.display = 'block';
          document.querySelector('.mm-dc-free-item-progress-text_not_yet').style.display = 'none';
        } else {
          document.querySelector('.mm-dc-free-item-progress-text_succes').style.display = 'none';
          document.querySelector('.mm-dc-free-item-progress-text_not_yet').style.display = 'block';
        }
        const montantRestant = document.querySelector('.mm-dc-free-item-progress-text span'); // Dumas style
        if (montantRestant) {
          montantRestant.innerText = ((document.getElementById('mmCartProgressBarValue').value - data.total_price) / 100).toFixed(2);
        }
        updateCartCount(data.item_count != null ? data.item_count : 0);
      }

      document.querySelector('.mm-dc-bottom').innerHTML = extractFooterFromCartHTML(data).innerHTML;

      document.dispatchEvent(new CustomEvent('deployer:cart-update', { detail: { data: data } }));

      return data;
    })
    .then((data) => {
      if (data.status && data.status > 400) {
        throw data;
      } else {
        return data;
      }
    });
}

// récupérer le panier
function mmGetCart() {
  mmAPIRequest('GET', 'cart.js').then(console.log);
}

const mmExtensions = ['.weglot-container', '#gorgias-chat-container'];

// Ouvrir le panier
function mmOpenCart() {
  document.querySelector('.mm-drawer-cart-filter').classList.add('mm-dc-is-open');
  document.querySelector('html').classList.add('stop-scrolling');
  mmExtensions.forEach((extensionSelector) => {
    const el = document.querySelector(extensionSelector);
    if (el) {
      el.style.display = 'none';
    }
  });
}

// Fermer le panier
function mmCloseCart() {
  document.querySelector('.mm-drawer-cart-filter').classList.remove('mm-dc-is-open');
  document.querySelector('html').classList.remove('stop-scrolling');
  mmExtensions.forEach((extensionSelector) => {
    const el = document.querySelector(extensionSelector);
    if (el) {
      el.style.removeProperty('display');
    }
  });
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
  const newCartEl = document.createElement('DIV');
  newCartEl.innerHTML = data.sections[mmGetSectionCartId()]
    .replaceAll('<cart-discount', '<b-cart-discount')
    .replaceAll('</cart-discount', '</b-cart-discount')
    .replaceAll('<discount-popup', '<b-discount-popup')
    .replaceAll('</discount-popup', '</b-discount-popup');
  const innerCart = mmCartSectionElement().querySelector('.mm-drawer-cart-filter');
  innerCart.innerHTML = newCartEl.querySelector('.mm-drawer-cart-filter').innerHTML;

  document.querySelector('b-cart-discount').outerHTML = newCartEl
    .querySelector('b-cart-discount')
    .outerHTML.replaceAll('<b-cart-discount', '<cart-discount')
    .replaceAll('</b-cart-discount', '</cart-discount')
    .replaceAll('<b-discount-popup', '<discount-popup')
    .replaceAll('</b-discount-popup', '</discount-popup');
  updateCartCount(newCartEl.querySelector('[data-cart-count]').dataset.cartCount);
  mmInitSplide();
  mmAddOrRemoveFreeProducts(data);
  document.dispatchEvent(new CustomEvent('deployer:upsell-update'));
}

// Ajouter un item au panier
function mmAddProductToCart(productId, quantity = 1, openCart = true, properties = {}) {
  var cartItem = { quantity: quantity, id: productId, properties: properties };

  mmAPIRequest('POST', 'cart/add.js', {
    items: [cartItem],
    sections: mmGetSectionCartId(),
    sections_url: window.location.pathname,
  })
    .then(refreshCartFromData)
    .then((data) => {
      if (openCart) {
        setTimeout(mmOpenCart);
      }
      document.querySelector('discount-popup').dispatchEvent(new Event('reinit'));
      document.querySelector('discount-popup').removeGiftNotDiscounted();
    })
    .catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
      Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      mmOpenCart();
      console.log(error);
    });
}

function mmIncreaseProductQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  const newQuantity = quantity + 1;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  const newQuantity = quantity - 1;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId, codePromo) {
  const newQuantity = 0;

  if (codePromo) {
    document.querySelector('cart-discount').dispatchEvent(new Event('discount:remove'));
  }

  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyFreeProductFromCart(productVariantId, newVariantId) {
  const newQuantity = 0;
  mmSetCartItemQuantity(productVariantId, newQuantity);

  mmDebouncedPushNewQuantityFree(productVariantId, newVariantId);
}

function mmPushNewQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);

  mmAPIRequest('POST', 'cart/change.js', {
    id: productVariantId.toString(),
    quantity: quantity,
    sections: [mmGetSectionCartId()],
    sections_url: window.location.pathname,
  })
    .then((data) => {
      insertCartProductsFromResponse(data);
      return data;
    })
    .then((data) => {
      insertInsertTotalPriceFromResponse(data);
      return data;
    })
    .then((data) => {
      mmAddOrRemoveFreeProducts(data);
    })
    .then((data) => {
      document.querySelector('discount-popup').dispatchEvent(new Event('reinit'));
      document.querySelector('discount-popup').removeGiftNotDiscounted();
      setTimeout(function () {
        document.querySelector('discount-popup').removeGiftNotDiscounted();
      }, 1000);
    });
}

function mmPushNewQuantityFree(productVariantId, newVariantId) {
  mmAPIRequest('POST', 'cart/change.js', {
    id: productVariantId.toString(),
    quantity: 0,
    sections: mmGetSectionCartId(),
    sections_url: window.location.pathname,
  })
    .then(insertCartProductsFromResponse)
    .then(insertInsertTotalPriceFromResponse);
  //.then(mmAddProductToCart(newVariantId, { quantity: 1, openCart: true }));
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
  mmPushNewQuantity(productVariantId);
}, 300);

const mmDebouncedPushNewQuantityFree = debounce(function (productVariantId, newVariantId) {
  mmPushNewQuantityFree(productVariantId, newVariantId);
}, 300);

function mmAddOrRemoveFreeProducts(data) {
  if (data.sections[mmGetSectionCartId()].replaceAll('cart-discount', 'b-cart-discount').replaceAll('discount-popup', 'b-discount-popup')) {
    const el = mmCartHTMLFromData(data);
    const freeProductEls = el.querySelector('[data-free-products]');
    let freeProductCounts = 0;

    // creates an object like { 44058675: 1, 44058001: 0 }
    // where key is free product variant id and the value is its quantity
    const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
      const productId = freeProductEl.dataset.productId;
      const isFree = freeProductEl.dataset.freeProduct == 'true';
      const itemEl = mmCartProduct(productId);
      const variantId = itemEl?.dataset?.cartVariantId || freeProductEl.dataset.variantId;

      if (isFree) {
        freeProductCounts += 1;
      }
      if (itemEl && isFree) {
        // do nothing, item is already added
      } else if (itemEl && !isFree) {
        // item is present but should be removed
        param[variantId] = 0;
      } else if (!itemEl && isFree) {
        // item is absent but should be added
        param[variantId] = 1;
      }
      return param;
    }, {});

    // Add or remove free products only if needed
    if (Object.keys(productsParams).length > 0) {
      mmAPIRequest('POST', 'cart/update.js', {
        updates: productsParams,
        sections: mmGetSectionCartId(),
        sections_url: window.location.pathname,
      }).then(insertCartProductsFromResponse);
    }
  }
  return data;
}

// CROSS SELL VARIANTS

function mmOpenVariantPopUp(id, index) {
  var variantPopUp = document.querySelector(`.mm-dc-product-variant-popup-${id}-${index}`);
  variantPopUp.classList.add('mm-open');
  if (variantPopUp.querySelector('engraved-component')) {
    let selectColor = variantPopUp.querySelector('select.mm-upsell-variant-values');
    selectColor.addEventListener('change', () => {
      variantPopUp.querySelector('engraved-component').dispatchEvent(new CustomEvent('deployer:upsellColorChange'));
    })
  }
}
function mmCloseVariantPopUp(elemClass) {
  var elem = document.querySelector(elemClass);
  setTimeout(() => {
    elem.classList.remove('mm-open');
  }, '300');
}
function changeVariant(elemClass) {
  var elem = document.querySelector(elemClass);
  setTimeout(() => {
    elem.classList.remove('mm-open');
  }, '300');
}

function upsellVariantPopupChange(variantsContainerClass) {
  var variantsContainer = document.querySelector(variantsContainerClass);

  options = Array.from(variantsContainer.querySelectorAll('select.mm-upsell-variant-values'), (select) => select.value);

  var variantData = variantData || JSON.parse(variantsContainer.querySelector('.mm-upsell-json[type="application/json"]').textContent);

  var currentVariant = variantData.find((variant) => {
    const findings = !variant.options
      .map((option, index) => {
        return options[index] === option;
      })
      .includes(false);

    if (findings) return variant;
  });
}

function upsellAddToCart(hasEngraving = false) {
  const container = document.querySelector('.mm-dc-product-variant-popup.mm-open');
  const productId = container.querySelector('input[name="id"]').value;
  if (hasEngraving) {
    const checkboxElement = container.querySelector('#cart-engraving-checkbox');
    const engravingTextContainer = container.querySelector('#cart-engraving-text-property');
    const engravingText = engravingTextContainer ? engravingTextContainer.textContent.trim() : '';
    const engravingSelect = container.querySelector('#cart-engraving-text-font');
    const engravingSelectValue = engravingSelect.dataset.font;
    const engravingOrientationInputs = container.querySelectorAll('[name="engraving-orientation"]');

    let engravingOrientationValue;
    for (var i = 0; i < engravingOrientationInputs.length; i++) {
      if (engravingOrientationInputs[i].checked) {
        engravingOrientationValue = engravingOrientationInputs[i].value;
        break;
      }
    }

    if (checkboxElement.checked == true && engravingText !== '') {
      const properties = {
        text: engravingText,
        font: engravingSelectValue,
        orientation: engravingOrientationValue,
      };
      mmAddProductToCart(productId, 1, true, properties);
    } else if (checkboxElement.checked == true && engravingText === '') {
      window.alert('Vous devez indiquer un texte pour valider votre gravure.');
    } else {
      mmAddProductToCart(productId);
    }
  } else {
    mmAddProductToCart(productId);
  }
}

// Change free product variant
function changeFreeProductVariant(selectElem, currentVariantId) {
  var newVariantId = selectElem.value;

  mmDestroyFreeProductFromCart(currentVariantId, newVariantId);
  setTimeout(mmAddProductToCart.bind(null, newVariantId, { quantity: 1, openCart: true }), 1000);
  // mmAddProductToCart(newVariantId, { quantity: 1, openCart: true });
}

function updateCartCount(value) {
  document.querySelector('.cart-count-bubble > span').innerText = value;
}

document.addEventListener('DOMContentLoaded', setUpsellSelects);
document.addEventListener('deployer:upsell-update', setUpsellSelects);

function setUpsellSelects() {
  const upsellSelectContainers = document.querySelectorAll('.mm-upsell-variant-option');

  upsellSelectContainers.forEach((element) => {
    const select = element.querySelector('select');
    select.addEventListener('change', (event) => {
      let popupContainer = document.querySelector('.mm-dc-product-variant-popup.mm-open');
      let variantContainer = popupContainer.querySelector('input[name="id"]');

      variantContainer.value = event.target.value;
    });
  });
}
let count = 0;

class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.variant_id = this.dataset.discountProduct;
    this.discount_code = this.dataset.discountCode;
    this.discount_prefix = null;
    this.discount_prefix_product = null;
    this.discount_popup_code = this.dataset.discountPopupCode;
    if (this.dataset.discountPrefix != undefined) {
      this.discount_prefix = this.dataset.discountPrefix;
      this.discount_prefix_product = this.dataset.discountPrefixProduct;
    }

    this.discount_input = this.querySelector('input');
    this.API_URL = '';

    this.init();

    this.addEventListener('discount:remove', this.removeDiscount.bind(this));

    this.getCartAndCheckDiscount();
  }

  async getCartAndCheckDiscount() {
    await fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((res) => {
        let has_product_discounted = false;
        let code = null;

        if ('discount' in res.attributes) {
          code = res.attributes.discount.split('=')[0];

          for (const item of res.items) {
            for (const discount of item.discounts) {
              let d_d = discount.title.toLowerCase();
              let c_d = code.toLowerCase();

              if (c_d == d_d) {
                has_product_discounted = true;
              }
            }
          }

          for (const discount of res.cart_level_discount_applications) {
            let d_d = discount.title.toLowerCase();
            let c_d = code.toLowerCase();
            if (c_d == d_d) {
              has_product_discounted = true;
            }
          }

          if (has_product_discounted == false) {
            localStorage.removeItem('discountCode');
            mmAPIRequest('POST', 'cart/update.js', {
              attributes: {
                discount: null,
              },
              sections: mmGetSectionCartId(),
              sections_url: window.location.pathname,
            }).then(insertCartProductsFromResponse);
          }
        }
      });
  }

  init() {
    this.querySelector('button').addEventListener('click', this.submitDiscount.bind(this));
    this.querySelector('.cart-discount__remove--discount').addEventListener('click', this.removeDiscount.bind(this));

    const discount = localStorage.getItem('discountCode');

    // if (discount) {
    //   const discountCode = JSON.parse(discount).code;
    //   this.submitDiscount(null, true);
    // }
  }

  async removeDiscount() {
    const discount = localStorage.getItem('discountCode');
    document.querySelector('.cart-discount__loader').classList.remove('hidden');

    localStorage.removeItem('discountCode');

    let updates = {};

    for (const id of products_gift) {
      let element = document.querySelector('[onclick="mmDestroyProductFromCart(' + id + ')"]');
      if (element) {
        updates[id] = 0;
      }
    }

    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    await fetch('/discount/CLEAR');
    // await fetch('/checkout?discount=%20');
    setTimeout(function () {
      mmAPIRequest('POST', 'cart/update.js', {
        attributes: {
          discount: null,
        },
        sections: mmGetSectionCartId(),
        sections_url: window.location.pathname,
      }).then(insertCartProductsFromResponse);
    }, 200);

    this.querySelector('input').value = '';
  }

  async submitDiscount(e, is_test = false) {
    document.querySelector('#cart-discount').classList.remove('error');
    document.querySelector('.cart-discount__error')?.classList.add('hidden');
    const discountCode = this.querySelector('input').value;

    if (discountCode === '') {
      return;
    }

    if (discountCode.toLowerCase() == this.discount_popup_code.toLowerCase()) {
      document.querySelector('discount-popup').dispatchEvent(new Event('reinit'));
      return;
    }

    document.querySelector('.cart-discount__loader').classList.remove('hidden');

    if (discountCode === this.discount_code) {
      mmAddProductToCart(this.variant_id, { quantity: 1 }, false, { '_is-gift': 'true', '_discount-code': discountCode });
    } else {
      this.applyCode(discountCode, is_test);
    }
  }

  async applyCode(discountCode, is_test) {
    if (this.discount_prefix != null) {
      let discountCodeSplitted = discountCode.split('-')[0].toLowerCase();
      let lowerPrefix = this.discount_prefix.toLowerCase();
      if (discountCodeSplitted == lowerPrefix) {
        await this.addToCart(this.discount_prefix_product);
      }
    }

    document.querySelector('.cart-discount__loader').classList.remove('hidden');

    // applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
    // applyBtn.style.pointerEvents = 'none';
    fetch('/payments/config', { method: 'GET' })
      .then(function (response) {
        return response.json();
      })
      .then(
        function (data) {
          const checkout_json_url = '/wallets/checkouts/';
          let authorization_token = btoa(data.paymentInstruments.accessToken);
          fetch(window.Shopify.routes.root + 'cart.js', {})
            .then(function (res) {
              return res.json();
            })
            .then(
              function (data) {
                let body = {
                  checkout: {
                    country: Shopify.country,
                    discount_code: discountCode,
                    line_items: data.items,
                    presentment_currency: Shopify.currency.active,
                  },
                };
                fetch(checkout_json_url, {
                  headers: {
                    accept: '*/*',
                    'cache-control': 'no-cache',
                    authorization: 'Basic ' + authorization_token,
                    'content-type': 'application/json, text/javascript',
                    pragma: 'no-cache',
                    'sec-fetch-dest': 'empty',
                    'sec-fetch-mode': 'cors',
                    'sec-fetch-site': 'same-origin',
                  },
                  referrerPolicy: 'strict-origin-when-cross-origin',
                  method: 'POST',
                  mode: 'cors',
                  credentials: 'include',
                  body: JSON.stringify(body),
                })
                  .then(function (response) {
                    return response.json();
                  })
                  .then(
                    async function (data) {
                      if (data.checkout && data.checkout.applied_discounts.length > 0) {
                        let d = data.checkout.applied_discounts.find((d) => d.title.toUpperCase() === discountCode.toUpperCase());

                        if (d) {
                          let discountApplyUrl = '/discount/' + discountCode;
                          await fetch(discountApplyUrl, {}).then(function (response) {
                            return response.text();
                          });

                          let localStorageValue = {
                            code: d.title.trim(),
                            totalCart: data.checkout.total_line_items_price,
                          };
                          localStorage.setItem('discountCode', JSON.stringify(localStorageValue));
                          if (is_test == false) {
                            setTimeout(this.udpateCartPropertiesDiscount(discountCode + '=' + d.amount), 1000);
                          }
                        } else {
                          mmAPIRequest('POST', 'cart/update.js', {
                            attributes: {
                              discount: '',
                            },
                            sections: mmGetSectionCartId(),
                            sections_url: window.location.pathname,
                          }).then(insertCartProductsFromResponse);
                          localStorage.removeItem('discountCode');
                          fetch('/checkout?discount=%20');
                          fetch('/discount/CLEAR');
                        }
                      } else {
                        fetch('/checkout?discount=%20');
                        document.querySelector('#cart-discount').classList.add('error');
                        mmAPIRequest('POST', 'cart/update.js', {
                          attributes: {
                            discount: '',
                          },
                          sections: mmGetSectionCartId(),
                          sections_url: window.location.pathname,
                        }).then(insertCartProductsFromResponse);
                        localStorage.removeItem('discountCode');
                        fetch('/discount/CLEAR');
                      }
                    }.bind(this)
                  )
                  .finally(function (params) {
                    // applyBtn.innerHTML = 'APPLY';
                    // applyBtn.style.pointerEvents = 'all';
                  });
              }.bind(this)
            );
        }.bind(this)
      );
  }

  async addToCart(variantId) {
    await mmAPIRequest('POST', 'cart/add.js', {
      items: [{ id: variantId, quantity: 1 }],
      sections: mmGetSectionCartId(),
      sections_url: window.location.pathname,
    }).then({});
  }

  udpateCartPropertiesDiscount(discount) {
    if (discount) {
      // POST CART.JS to add discount object on cart attributes
      // Then refresh cart

      mmAPIRequest('POST', 'cart/update.js', {
        attributes: {
          discount: discount,
        },
        sections: mmGetSectionCartId(),
        sections_url: window.location.pathname,
      }).then(insertCartProductsFromResponse);
    } else {
    }
  }
}

customElements.define('cart-discount', CartDiscount);

// Upsell engraved
class EngravedComponent extends HTMLElement {
  constructor() {
    super();
    this.customizeBtn = this.querySelector('#cart-engraving-btn');
    this.customizeBtnCheck = this.querySelector('input');
    this.customizationContainer = this.querySelector('#cart-engraving-container');
    this.inputText = this.querySelector('#cart-engraving-text');
    this.isExpanded = false;
    this.customSelect = this.querySelector('#cart-engraving-text-font-select');
    this.selectedOption = this.customSelect.querySelector('.selected-option');
    this.selectOptions = this.customSelect.querySelector('.options');
    this.optionItems = this.customSelect.querySelectorAll('.option');
    this.initEngravingInput();
    this.initSelectedOption();
    this.initEventsListener();
  }

  initEventsListener() {
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('deployer:upsellColorChange', this.onVariantChange);

    this.customizeBtn.addEventListener('click', () => this.expandContainer());

    this.selectedOption.addEventListener('click', () => {
      this.selectOptions.style.display = this.selectOptions.style.display === 'block' ? 'none' : 'block';
      const currentHeight = this.customizationContainer.scrollHeight;
      const optionsHeight = this.selectOptions.getBoundingClientRect().height;
      if (this.selectOptions.style.display === 'block') {
        this.customizationContainer.style.maxHeight = `${currentHeight + optionsHeight}px`;
      } else {
        this.customizationContainer.style.maxHeight = `${currentHeight - optionsHeight}px`;
      }
    });

    this.optionItems.forEach((option) => {
      option.addEventListener('click', () => {
        this.selectedOption.childNodes[0].textContent = option.textContent;
        this.selectOptions.style.display = 'none';
        const selectedValue = option.getAttribute('data-value');
        const selectedFont = option.getAttribute('data-font');
        this.selectedOption.style.fontFamily = selectedFont;
        this.selectedOption.setAttribute('data-value', selectedValue);
        this.selectedOption.setAttribute('data-font', selectedFont);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.customSelect.contains(e.target)) {
        this.selectOptions.style.display = 'none';
      }
    });
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      this.updateCTA();
      this.updateFormID();
    }
  }

  updateFormID() {
    let popupContainer = document.querySelector('.mm-dc-product-variant-popup.mm-open');
    let variantContainer = popupContainer.querySelector('input[name="id"]');
    variantContainer.value = this.currentVariant.id;
  }

  getSelectedOptions() {
    let popupContainer = document.querySelector('.mm-dc-product-variant-popup.mm-open');
    let selectColor = popupContainer.querySelector('.mm-upsell-variant-values');

    let selectedOption = selectColor.options[selectColor.selectedIndex].dataset.option;

    this.options = [selectedOption];
    this.options.push(...Array.from(this.querySelectorAll('.mm-product-variant-checkbox:checked'), (checkbox) => checkbox.value));
  }

  getVariantJSON() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  updateCTA() {
    const CTA = document.querySelector('.mm-dc-product-variant-popup.mm-open').querySelector('#upsell-cart-btn');
    if (this.currentVariant.available) {
      CTA.classList.remove('mm-btn-disabled');
    } else {
      CTA.classList.add('mm-btn-disabled');
    }
  }

  initEngravingInput() {
    const inputContainer = this.querySelector('#cart-engraving-text-container');
    const options = inputContainer.querySelectorAll('.mm-product-variant-checkbox');
    const checkboxElement = this.querySelector('#cart-engraving-checkbox');
    const inputTextProperty = this.querySelector('#cart-engraving-text-property');

    if (this.inputText) {
      this.inputText.addEventListener('input', () => {
        inputTextProperty.textContent = this.inputText.value.trim();
      });
    }

    if (checkboxElement) {
      checkboxElement.addEventListener('change', async () => {
        for (const option of options) {
          if (
            (checkboxElement.checked == false && option.value === 'Sans gravure') ||
            (checkboxElement.checked == true && option.value === 'Avec gravure')
          ) {
            option.checked = true;
          } else {
            option.checked = false;
          }
        }

        await new Promise((resolve) => setTimeout(resolve, 0));
        this.onVariantChange();
      });
    }
  }

  expandContainer() {
    const event = new Event('change');
    if (this.isExpanded) {
      this.customizationContainer.style.maxHeight = '0';
      this.customizeBtnCheck.checked = false;
      this.customizeBtnCheck.dispatchEvent(event);
      this.inputText.value = '';
      this.triggerInputEvent(this.inputText);
    } else {
      this.customizationContainer.style.maxHeight = `${this.customizationContainer.scrollHeight}px`;
      this.customizeBtnCheck.checked = true;
      this.customizeBtnCheck.dispatchEvent(event);
    }
    this.isExpanded = !this.isExpanded;
  }

  triggerInputEvent(element) {
    const event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    element.dispatchEvent(event);
  }

  initSelectedOption() {
    var defaultOption = this.customSelect.querySelector('.option.selected');
    this.selectedOption.childNodes[0].textContent = defaultOption.textContent;
    this.selectedOption.setAttribute('data-value', defaultOption.getAttribute('data-value'));
    this.selectedOption.setAttribute('data-font', defaultOption.getAttribute('data-font'));
  }
}

customElements.define('engraved-component', EngravedComponent);

class DiscountPopup extends HTMLElement {
  constructor() {
    super();
    this.initEventListeners();
    this.max_gifts = parseInt(document.querySelector('[data-discount-popup-max-gift]').dataset.discountPopupMaxGift);
    this.current_gifts = {};
    this.total_gifts = 0;
    this.current_selection = 0;
    this.step_gift = parseInt(document.querySelector('[data-discount-popup-step-gift]').dataset.discountPopupStepGift);
    this.discount_code = document.querySelector('[data-discount-popup-code]').dataset.discountPopupCode;
    this.eligible_gift = 0;
    this.tasks_on = false;
    this.onSubmit = false;
    this.initVars();

    this.variants_eligible = variants_eligible;
    this.products_gift = products_gift;

    this.removeGiftNotDiscounted();
    this.setMinHeightTitle();
  }

  setMinHeightTitle() {
    let titles = this.querySelectorAll('.mm-2-pc-title');
    let maxHeight = 0;
    titles.forEach((title) => {
      if (title.clientHeight > maxHeight) {
        maxHeight = title.clientHeight;
      }
    });

    titles.forEach((title) => {
      title.style.minHeight = maxHeight + 'px';
    });
  }

  initEventListeners() {
    this.querySelectorAll('.discount-popup-select').forEach((el) => {
      el.addEventListener('click', this.handleSelectProduct.bind(this));
    });

    this.querySelectorAll('.discount-popup__quantity-btn').forEach((el) => {
      el.addEventListener('click', this.handleQuantity.bind(this));
    });

    this.querySelector('.discount-popup-close').addEventListener('click', () => {
      this.close();
    });

    this.querySelector('.discount-popup-submit').addEventListener('click', this.submitSelection.bind(this));

    this.addEventListener('reinit', this.getGiftsNumber.bind(this));
  }

  initVars() {
    // set vh css variable
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    window.addEventListener('resize', () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    });
  }

  close() {
    document.querySelector('#chat-button')?.classList.remove('hidden');
    this.classList.add('hidden');
  }

  open() {
    document.querySelector('#chat-button')?.classList.add('hidden');
    this.classList.remove('hidden');
    this.setMinHeightTitle();
  }

  handleSelectProduct(e) {
    this.current_gifts = Array.from(this.querySelectorAll('.discount-popup__quantity input')).reduce((acc, item) => {
      return acc + parseInt(item.value);
    }, 0);
    if (this.current_gifts < this.eligibility_count) {
      let input = e.currentTarget.nextElementSibling.querySelector('input');
      let current_quantity = input.value;
      let product = e.target.closest('.mm-product-card');
      input.value = 1;

      e.currentTarget.nextElementSibling.classList.remove('hidden');
      e.currentTarget.classList.add('hidden');
      this.updateButtons();
    }
  }

  handleQuantity(e) {
    let input = e.currentTarget.closest('.discount-popup__quantity').querySelector('input');
    let current_quantity = parseInt(input.value);
    let action = e.currentTarget.dataset.action;

    if (action === 'increment' && this.current_gifts < this.eligibility_count) {
      input.value = current_quantity + 1;
    } else if (action === 'decrement' && current_quantity > 0) {
      input.value = current_quantity - 1;

      if (current_quantity === 1) {
        e.currentTarget.closest('.discount-popup__quantity').classList.add('hidden');
        e.currentTarget.closest('.mm-product-card').querySelector('.discount-popup-select').classList.remove('hidden');
      }
    }

    this.updateButtons();
  }

  updateButtons() {
    this.current_gifts = Array.from(this.querySelectorAll('.discount-popup__quantity input')).reduce((acc, item) => {
      return acc + parseInt(item.value);
    }, 0);

    if (this.current_gifts >= this.eligibility_count) {
      this.querySelectorAll('.discount-popup__quantity-btn[data-action="increment"], .discount-popup-select').forEach((el) => {
        el.setAttribute('disabled', true);
      });
    } else {
      this.querySelectorAll('.discount-popup__quantity-btn[data-action="increment"], .discount-popup-select').forEach((el) => {
        el.removeAttribute('disabled');
      });
    }
  }

  async getCartItems() {
    let response = await fetch(window.Shopify.routes.root + 'cart.js');
    let data = await response.json();
    return data.items;
  }

  async getGiftsNumber() {
    let current_code = document.querySelector('#cart-discount').value;
    let discount_code = document.querySelector('[data-discount-popup-code]').dataset.discountPopupCode;

    if (current_code.toLowerCase() == discount_code.toLowerCase()) {
      let cart_items = await this.getCartItems();
      this.total_gifts = 0;
      this.eligible_gift = 0;

      let has_subscription = false;

      for (const item of cart_items) {
        if (item.hasOwnProperty('selling_plan_allocation')) {
          has_subscription = true;
        }
        if (this.variants_eligible.includes(item.variant_id) && !item.hasOwnProperty('selling_plan_allocation')) {
          this.eligible_gift += item.quantity;
        }
        if (this.products_gift.includes(item.variant_id)) {
          this.total_gifts += item.quantity;
        }
      }

      // if (has_subscription) {
      //   document.querySelector('#cart-discount').classList.add('error');
      //   document.querySelector('.cart-discount__error').classList.remove('hidden');
      //   // return;
      // }

      this.remaining_gifts = Math.floor(this.eligible_gift / this.step_gift);
      this.eligibility_count = this.remaining_gifts;

      if (this.eligibility_count > this.max_gifts) {
        this.eligibility_count = this.max_gifts;
      }

      this.remaining_gifts = this.eligibility_count;

      this.remaining_gifts = this.remaining_gifts - this.total_gifts;

      this.querySelector('.nb-tubes').textContent = this.eligibility_count;
      this.querySelectorAll('.plurial').forEach((item) => {
        item.textContent = this.eligibility_count > 1 ? 's' : '';
      });

      if (this.eligibility_count > 1) {
        this.querySelector('.discount-popup-submit').innerHTML = this.querySelector('.discount-popup-submit').innerHTML.replace(
          'mon',
          'mes'
        );
        this.querySelector('.discount-popup-submit').innerHTML = this.querySelector('.discount-popup-submit').innerHTML.replace(
          'cadeau',
          'cadeaux'
        );
      } else {
        this.querySelector('.discount-popup-submit').innerHTML = this.querySelector('.discount-popup-submit').innerHTML.replace(
          'mes',
          'mon'
        );
        this.querySelector('.discount-popup-submit').innerHTML = this.querySelector('.discount-popup-submit').innerHTML.replace(
          'cadeaux',
          'cadeau'
        );
      }

      if (this.total_gifts >= this.max_gifts) {
        // this.close();
      } else {
        if (this.remaining_gifts > 0) {
          this.open();
        } else {
          if (this.total_gifts == 0) {
            document.querySelector('#cart-discount').classList.add('error');
          } else {
          }
        }
      }

      this.updateSelection();
    }
  }

  updateSelection() {
    this.querySelectorAll('.discount-popup__quantity input').forEach((el) => {
      let variant_id = el.closest('.mm-product-card--popup').dataset.variantId;

      let item = document.querySelector(`#shopify-section-mm-cart [data-cart-item-id="${variant_id}"] [data-item-quantity]`);
      let current_qty = item ? parseInt(item.dataset.itemQuantity) : 0;

      el.value = current_qty ? current_qty : 0;

      if (el.value > 0) {
        el.closest('.discount-popup__quantity').classList.remove('hidden');
        el.closest('.mm-product-card').querySelector('.discount-popup-select').classList.add('hidden');
      } else {
        el.closest('.discount-popup__quantity').classList.add('hidden');
        el.closest('.mm-product-card').querySelector('.discount-popup-select').classList.remove('hidden');
      }
    });

    this.updateButtons();
  }

  async submitSelection(e) {
    if (this.onSubmit == false) {
      this.onSubmit = true;
      let cart_items = await this.getCartItems();

      let selected_variants = Array.from(this.querySelectorAll('.discount-popup__quantity input')).reduce((acc, item) => {
        let variant_id = item.closest('.mm-product-card').dataset.variantId;
        let quantity = parseInt(item.value);

        if (quantity > 0) {
          acc.push({
            variant_id: variant_id,
            quantity: quantity,
          });
        }

        return acc;
      }, []);

      for (const item of cart_items) {
        for (const discount of item.discounts) {
          if (discount.title === this.discount_code && discount.amount > 0) {
            // check if in selected_variants
            let selected_variant = selected_variants.find((variant) => variant.variant_id === item.variant_id);

            if (!selected_variant || selected_variant.quantity === 0) {
              await fetch(window.Shopify.routes.root + `cart/change.js?quantity=0&id=${item.variant_id}`);
            }
          }
        }
      }

      for (const variant of selected_variants) {
        await fetch(window.Shopify.routes.root + `cart/add.js?quantity=${variant.quantity}&id=${variant.variant_id}`);
      }

      document.querySelector('cart-discount').applyCode(this.discount_code, false);
      this.close();
      this.onSubmit = false;
    }
  }

  removeGiftNotDiscounted() {
    for (const id of this.products_gift) {
      let element = document.querySelector(`[data-cart-item-id="${id}"]`);
      if (element) {
        let price = parseInt(document.querySelector(`[data-cart-item-id="${id}"]`).dataset.price);
        if (price != 0) {
          mmDestroyProductFromCart(id);
        }
      }
    }
  }

  loader(show) {
    if (show) {
      document.querySelector('cart-discount').classList.add('loading');
    } else {
      document.querySelector('cart-discount').classList.remove('loading');
    }
  }
}

customElements.define('discount-popup', DiscountPopup);
